import { atom } from "jotai";

import _ from "lodash";

interface IPublishState {
  lastpublish: string | null;
  lastchange: string | null;
}

// Both schoolphotos and student works use this atom
const schoolphotosPublishAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

const slidesPublishAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

const changesSchema = JSON.stringify({
  lastchange: "string",
  lastpublish: "string",
});

export { schoolphotosPublishAtom, slidesPublishAtom, changesSchema };
export type { IPublishState };
